export interface LocaleText {
  pt: string;
  es: string;
  en: string;
}

export const ADMIN: LocaleText = {
  pt: "Admin",
  es: "Admin",
  en: "Admin",
};

export const MANAGEMENT: LocaleText = {
  pt: "Administração",
  es: "Administración",
  en: "Administration",
};

export const PIX_HEALTH_CHECK: LocaleText = {
  pt: "PIX Health Check",
  es: "PIX Health Check",
  en: "PIX Health Check",
};

export const PIX_HEALTH_CHECK_TITLE: LocaleText = {
  pt: "Health Check do PIX",
  es: "Health Check de PIX",
  en: "PIX Health Check",
};

export const OOPS: LocaleText = {
  pt: "Ops...",
  es: "Epa...",
  en: "Ops...",
};

export const SUCCESS: LocaleText = {
  pt: "Sucesso!",
  es: "¡Éxito!",
  en: "Success!",
};

export const YES: LocaleText = {
  pt: "Sim",
  es: "Sí",
  en: "Yes",
};

export const NO: LocaleText = {
  pt: "Não",
  es: "No",
  en: "No",
};

export const ENABLED: LocaleText = {
  pt: "Habilitado",
  es: "Habilitado",
  en: "Enabled",
};

export const DISABLED: LocaleText = {
  pt: "Desabilitado",
  es: "Deshabilitado",
  en: "Disabled",
};

export const STATUS_INFORMATION: LocaleText = {
  pt: "Informações de Status",
  es: "Información de Estado",
  en: "Status Information",
};

export const CURRENT_STATUS: LocaleText = {
  pt: "Status Atual",
  es: "Estado Actual",
  en: "Current Status",
};

export const ACTUAL_STATUS: LocaleText = {
  pt: "Status Real",
  es: "Estado Real",
  en: "Actual Status",
};

export const FEATURE_STATUS: LocaleText = {
  pt: "Funcionalidade no aplicativo",
  es: "Funcionalidad en la aplicación",
  en: "Feature in application",
};

export const OVERRIDE_ACTIVE: LocaleText = {
  pt: "Status manual",
  es: "Estado manual",
  en: "Manual Status",
};

export const OVERRIDE_STATUS: LocaleText = {
  pt: "Status do sobrescrita",
  es: "Estado del sobrescrita",
  en: "Override Status",
};

export const OVERRIDE_SET_BY: LocaleText = {
  pt: "Definido por",
  es: "Definido por",
  en: "Set By",
};

export const OVERRIDE_SET_AT: LocaleText = {
  pt: "Definido em",
  es: "Definido en",
  en: "Set At",
};

export const LAST_CHECK_STATUS: LocaleText = {
  pt: "Status do Último Check",
  es: "Estado del Último Check",
  en: "Last Check Status",
};

export const LAST_CHECK_LATENCY: LocaleText = {
  pt: "Latência do Último Check",
  es: "Latencia del Último Check",
  en: "Last Check Latency",
};

export const LAST_CHECK_ERROR: LocaleText = {
  pt: "Erro do Último Check",
  es: "Error del Último Check",
  en: "Last Check Error",
};

export const LAST_CHECK_TIME: LocaleText = {
  pt: "Horário do Último Check",
  es: "Hora del Último Check",
  en: "Last Check Time",
};

export const OVERRIDE_CONTROLS: LocaleText = {
  pt: "Sobrescrita Manual do Status Pix (Aplicativo)",
  es: "Sobrescrita Manual del Estado de PIX (Aplicativo)",
  en: "Manual PIX Status Override (Application)",
};

export const OVERRIDE_DESCRIPTION: LocaleText = {
  pt: "Esta funcionalidade permite forçar manualmente a disponibilidade ou indisponibilidade do Pix na tela de adição de saldo do aplicativo. Utilize este controle apenas em casos de manutenção programada ou incidentes graves que exijam a interrupção da funcionalidade.",
  es: "Esta funcionalidad permite forzar manualmente la disponibilidad o inactividad de PIX en la pantalla de adición de saldo de la aplicación. Utilice este control solo en casos de mantenimiento programado o incidentes graves que requieran la interrupción de la funcionalidad.",
  en: "This feature allows you to manually force the availability or unavailability of PIX on the add balance screen of the application. Use this control only in cases of scheduled maintenance or serious incidents that require the interruption of the functionality.",
};

export const SET_UP: LocaleText = {
  pt: "Forçar Pix como ATIVO",
  es: "Forzar PIX como ACTIVO",
  en: "Force PIX as ACTIVE",
};

export const SET_DOWN: LocaleText = {
  pt: "Forçar Pix como INATIVO",
  es: "Forzar PIX como INACTIVO",
  en: "Force PIX as INACTIVE",
};

export const CLEAR_OVERRIDE: LocaleText = {
  pt: "Remover Sobrescrita Manual",
  es: "Eliminar Sobrescrita Manual",
  en: "Clear Manual Override",
};

export const CONFIRM_SET_UP: LocaleText = {
  pt: "Tem certeza que deseja forçar o Pix como ATIVO?",
  es: "¿Estás seguro de que deseas forzar PIX como ACTIVO?",
  en: "Are you sure you want to force PIX as ACTIVE?",
};

export const CONFIRM_SET_DOWN: LocaleText = {
  pt: "Tem certeza que deseja forçar o Pix como INATIVO?",
  es: "¿Estás seguro de que deseas forzar PIX como INACTIVO?",
  en: "Are you sure you want to force PIX as INACTIVE?",
};

export const CONFIRM_CLEAR_OVERRIDE: LocaleText = {
  pt: "Tem certeza que deseja remover a sobrescrita manual? O sistema voltará a usar o status real do health check.",
  es: "¿Estás seguro de que deseas eliminar la sobrescrita manual? El sistema volverá a usar el estado real del health check.",
  en: "Are you sure you want to clear the manual override? The system will return to using the actual health check status.",
};

export const FEATURE_CONTROLS: LocaleText = {
  pt: "Pix Health Check (Feature flag)",
  es: "Health Check de PIX (Feature flag)",
  en: "PIX Health Check (Feature flag)",
};

export const FEATURE_DESCRIPTION: LocaleText = {
  pt: "✅ Ao desabilitar o Health Check Pix, a opção de adicionar saldo via Pix ficará visível e disponível para TODOS os usuários no aplicativo.",
  es: "✅ Cuando el Health Check Pix está deshabilitado, la opción de agregar saldo a través de PIX estará visible y disponible para TODOS los usuarios en la aplicación.",
  en: "✅ When the PIX Health Check is disabled, the option to add balance via PIX will be visible and available for ALL users in the application.",
};

export const FEATURE_IMPORTANT: LocaleText = {
  pt: "⚠️ Importante: Mesmo desabilitado, o sistema continuará monitorando em segundo plano e registrando o histórico de status do Pix para consulta futura.",
  es: "⚠️ Importante: Aunque esté deshabilitado, el sistema continuará monitorizando en segundo plano y registrando el historial de estado de PIX para consulta futura.",
  en: "⚠️ Important: Even disabled, the system will continue monitoring in the background and recording the PIX status history for future reference.",
};

export const ENABLE_FEATURE: LocaleText = {
  pt: "Habilitar Pix Health Check",
  es: "Habilitar Health Check de PIX",
  en: "Enable PIX Health Check",
};

export const DISABLE_FEATURE: LocaleText = {
  pt: "Desabilitar Pix Health Check",
  es: "Deshabilitar Health Check de PIX",
  en: "Disable PIX Health Check",
};

export const CONFIRM_ENABLE_FEATURE: LocaleText = {
  pt: "Tem certeza que deseja habilitar a feature? O endpoint público passará a retornar o status real do health check.",
  es: "¿Estás seguro de que deseas habilitar el Health Check de PIX? El endpoint público comenzará a devolver el estado real del health check.",
  en: "Are you sure you want to enable the PIX Health Check? The public endpoint will start returning the actual health check status.",
};

export const CONFIRM_DISABLE_FEATURE: LocaleText = {
  pt: "Tem certeza que deseja desabilitar o Pix Health Check? O endpoint público sempre retornará PIX como disponível.",
  es: "¿Estás seguro de que deseas deshabilitar el Health Check de PIX? El endpoint público siempre devolverá PIX como disponible.",
  en: "Are you sure you want to disable the PIX Health Check? The public endpoint will always return PIX as available.",
};

export const REFRESH: LocaleText = {
  pt: "Atualizar",
  es: "Actualizar",
  en: "Refresh",
};

export const ERROR_FETCHING_STATUS: LocaleText = {
  pt: "Erro ao buscar status do health check",
  es: "Error al obtener el estado del health check",
  en: "Error fetching health check status",
};

export const ERROR_SETTING_OVERRIDE: LocaleText = {
  pt: "Erro ao definir sobrescrita",
  es: "Error al definir sobrescrita",
  en: "Error setting override",
};

export const ERROR_CLEARING_OVERRIDE: LocaleText = {
  pt: "Erro ao remover sobrescrita",
  es: "Error al eliminar sobrescrita",
  en: "Error clearing override",
};

export const ERROR_TOGGLING_FEATURE: LocaleText = {
  pt: "Erro ao alterar status da feature",
  es: "Error al cambiar el estado de la funcionalidad",
  en: "Error toggling feature status",
};

export const OVERRIDE_SET_SUCCESS: LocaleText = {
  pt: "Sobrescrita definido com sucesso!",
  es: "¡Sobrescrita definido con éxito!",
  en: "Override set successfully!",
};

export const OVERRIDE_CLEARED_SUCCESS: LocaleText = {
  pt: "Sobrescrita removido com sucesso!",
  es: "¡Sobrescrita eliminado con éxito!",
  en: "Override cleared successfully!",
};

export const FEATURE_ENABLED_SUCCESS: LocaleText = {
  pt: "Feature habilitada com sucesso!",
  es: "¡Funcionalidad habilitada con éxito!",
  en: "Feature enabled successfully!",
};

export const FEATURE_DISABLED_SUCCESS: LocaleText = {
  pt: "Feature desabilitada com sucesso!",
  es: "¡Funcionalidad deshabilitada con éxito!",
  en: "Feature disabled successfully!",
};

export const TAB_NOW: LocaleText = {
  pt: "Agora",
  es: "Ahora",
  en: "Now",
};

export const TAB_LIST: LocaleText = {
  pt: "Listagem",
  es: "Listado",
  en: "List",
};

export const TAB_VOLUME: LocaleText = {
  pt: "Volume",
  es: "Volumen",
  en: "Volume",
};

export const AUTO_OVERRIDE: LocaleText = {
  pt: "Override Automático",
  es: "Override Automático",
  en: "Auto Override",
};

export const AUTO_OVERRIDE_NONE: LocaleText = {
  pt: "Nenhum",
  es: "Ninguno",
  en: "None",
};

export const AUTO_OVERRIDE_ACTIVE_LABEL: LocaleText = {
  pt: "AUTO-DESABILITADO",
  es: "AUTO-DESHABILITADO",
  en: "AUTO-DISABLED",
};

export const AUTO_OVERRIDE_REASON: LocaleText = {
  pt: "Motivo",
  es: "Motivo",
  en: "Reason",
};

export const AUTO_OVERRIDE_SET_AT: LocaleText = {
  pt: "Detectado em",
  es: "Detectado en",
  en: "Detected At",
};

export const AUTO_OVERRIDE_PAID_RATIO: LocaleText = {
  pt: "Taxa de pagamento",
  es: "Tasa de pago",
  en: "Paid Ratio",
};

export const AUTO_OVERRIDE_PAID_USERS_LABEL: LocaleText = {
  pt: "usuários pagos",
  es: "usuarios pagados",
  en: "paid users",
};

export const AUTO_OVERRIDE_ALERT_TITLE: LocaleText = {
  pt: "PIX auto-desabilitado por volume baixo de pagamentos",
  es: "PIX auto-deshabilitado por volumen bajo de pagos",
  en: "PIX auto-disabled due to low payment volume",
};

export const CLEAR_AUTO_OVERRIDE: LocaleText = {
  pt: "Limpar Override Automático",
  es: "Limpiar Override Automático",
  en: "Clear Auto Override",
};

export const CONFIRM_CLEAR_AUTO_OVERRIDE: LocaleText = {
  pt: "Tem certeza que deseja limpar o override automático? O volume check continuará rodando e pode reaplicar o override automaticamente.",
  es: "¿Estás seguro de que deseas limpiar el override automático? El volume check seguirá ejecutándose y puede reaplicar el override automáticamente.",
  en: "Are you sure you want to clear the auto override? The volume check will keep running and may re-apply the override automatically.",
};

export const AUTO_OVERRIDE_CLEARED_SUCCESS: LocaleText = {
  pt: "Override automático removido com sucesso!",
  es: "¡Override automático eliminado con éxito!",
  en: "Auto override cleared successfully!",
};

export const ERROR_CLEARING_AUTO_OVERRIDE: LocaleText = {
  pt: "Erro ao remover override automático",
  es: "Error al eliminar override automático",
  en: "Error clearing auto override",
};

export const VOLUME_WINDOW: LocaleText = {
  pt: "Janela (UTC)",
  es: "Ventana (UTC)",
  en: "Window (UTC)",
};

export const VOLUME_AVG_USERS: LocaleText = {
  pt: "Média de Usuários Pagos",
  es: "Promedio de Usuarios Pagados",
  en: "Avg Paid Users",
};

export const VOLUME_DATA_POINTS: LocaleText = {
  pt: "Dias com Dados",
  es: "Días con Datos",
  en: "Days with Data",
};

export const VOLUME_CURRENT_WINDOW: LocaleText = {
  pt: "Janela atual",
  es: "Ventana actual",
  en: "Current window",
};

export const VOLUME_CURRENT_PAID_RATIO: LocaleText = {
  pt: "Taxa de Pagamento Atual",
  es: "Tasa de Pago Actual",
  en: "Current Paid Ratio",
};

export const VOLUME_THRESHOLDS: LocaleText = {
  pt: "Thresholds do Volume Check",
  es: "Umbrales del Volume Check",
  en: "Volume Check Thresholds",
};

export const VOLUME_MIN_USERS: LocaleText = {
  pt: "Mín. usuários",
  es: "Mín. usuarios",
  en: "Min. users",
};

export const VOLUME_MIN_PAID_RATIO: LocaleText = {
  pt: "Mín. taxa de pagamento",
  es: "Mín. tasa de pago",
  en: "Min. paid ratio",
};

export const VOLUME_LOW_VOLUME: LocaleText = {
  pt: "Volume baixo",
  es: "Volumen bajo",
  en: "Low volume",
};

export const ERROR_FETCHING_VOLUME_STATS: LocaleText = {
  pt: "Erro ao buscar estatísticas de volume",
  es: "Error al obtener estadísticas de volumen",
  en: "Error fetching volume stats",
};

export const ERROR_FETCHING_LIST: LocaleText = {
  pt: "Erro ao buscar listagem de health checks",
  es: "Error al obtener el listado de health checks",
  en: "Error fetching health check list",
};

export const STATUS: LocaleText = {
  pt: "Status",
  es: "Estado",
  en: "Status",
};

export const LATENCY: LocaleText = {
  pt: "Latência (ms)",
  es: "Latencia (ms)",
  en: "Latency (ms)",
};

export const ERROR_MESSAGE: LocaleText = {
  pt: "Mensagem de Erro",
  es: "Mensaje de Error",
  en: "Error Message",
};

export const CHECKED_AT: LocaleText = {
  pt: "Verificado em",
  es: "Verificado en",
  en: "Checked At",
};

export const STATUS_ACTIVE: LocaleText = {
  pt: "Ativo",
  es: "Activo",
  en: "Active",
};

export const STATUS_INACTIVE: LocaleText = {
  pt: "Inativo",
  es: "Inactivo",
  en: "Inactive",
};

export const STATUS_NA: LocaleText = {
  pt: "N/A",
  es: "N/A",
  en: "N/A",
};
